import { useEffect } from 'react';

/**
 * Custom hook to manage canonical URL tags in the document head.
 * This is a workaround for react-helmet-async's inconsistent handling of <link> tags.
 * 
 * @param {string} canonicalUrl - The canonical URL to set for the page
 */
export function useCanonical(canonicalUrl) {
  useEffect(() => {
    if (!canonicalUrl) return;
    
    // Remove any existing canonical link
    const existingCanonical = document.querySelector('link[rel="canonical"]');
    if (existingCanonical) {
      existingCanonical.remove();
    }
    
    // Add new canonical link
    const link = document.createElement('link');
    link.rel = 'canonical';
    link.href = canonicalUrl;
    document.head.appendChild(link);
    
    // Cleanup on unmount
    return () => {
      const canonical = document.querySelector('link[rel="canonical"]');
      if (canonical && canonical.href === canonicalUrl) {
        canonical.remove();
      }
    };
  }, [canonicalUrl]);
}

export default useCanonical;
